export const checkinEditDrawer = {
  header: {
    title: "Editar dados do check-in",
    age: "Idade:",
    docNotRequiredMinor: "Documento não obrigatório (menor de idade)",
    docOptionalMinorES: "Documento opcional (menor na Espanha)",
    docOptionalMinorCO: "Documento opcional (menor de 7 anos na Colômbia)",
  },
  sections: {
    basicData: "Dados básicos",
    stayDates: "Datas da estadia",
    italyDoc: "Documento e país de nascimento",
    doc: "Documento e nacionalidade",
  },
  fields: {
    firstName: "Nome",
    lastName: "Sobrenome",
    email: "E-mail",
    phone: "Telefone",
    birthDate: "Data de nascimento",
    sex: "Gênero",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Tipo de documento",
    docNumber: "Número do documento",
    supportNumber: "Número de suporte",
    nationality: "Nacionalidade",
  },
  placeholders: {
    select: "Selecione",
    selectNationality: "Selecione a nacionalidade",
    searchCountry: "Buscar país...",
    selectCountry: "— selecione o país —",
    docNumberExample: "ex.: AB1234567",
    docNumberGeneric: "DNI / NIE / Passaporte",
    required: "Obrigatório",
    optional: "Opcional",
  },
  sex: {
    male: "Masculino",
    female: "Feminino",
    preferNotToSay: "Prefiro não informar",
    other: "Outro",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "País de nascimento",
    birthCountryHint: "— também usado como cidadania",
    issuePlaceLabel: "Local de emissão do documento",
    issuePlaceHint: "— país onde o documento foi emitido",
    alloggiatiCode: "Código Alloggiati:",
    iso3Label: "ISO3:",
    minorNote:
      "Menor de idade — tipo, número e local de emissão do documento são enviados em branco ao Alloggiati Web (TABELLA 1).",
  },
  hints: {
    docOptional:
      "Documento opcional pela regra de idade/país. Mesmo assim, você pode preenchê-lo.",
  },
  docTypes: {
    it: {
      IDENT: "Documento de identidade (IDENT)",
      IDELE: "Documento de identidade eletrônico (IDELE)",
      PASOR: "Passaporte comum (PASOR)",
      PASSE: "Passaporte de serviço (PASSE)",
      PASDI: "Passaporte diplomático (PASDI)",
      PATEN: "Carteira de motorista (PATEN)",
      PATNA: "Habilitação náutica (PATNA)",
      CIDIP: "Identidade diplomática (CIDIP)",
      RIFUG: "Documento de viagem de refugiado (RIFUG)",
    },
    co: {
      CC: "Cédula de cidadania",
      CE: "Cédula de estrangeiro",
      P: "Passaporte",
      PPT: "Permissão de Proteção Temporária",
      PEP: "Permissão Especial de Permanência",
      DE: "Documento estrangeiro",
      CD: "Carteira diplomática",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "Passaporte",
      OTRO: "Outro",
    },
    generic: {
      ID: "Documento de identidade",
      P: "Passaporte",
      OTRO: "Outro",
    },
  },
  footer: {
    cancel: "Cancelar",
    save: "Salvar",
    saving: "Salvando...",
  },
  errors: {
    nameRequired: "Nome e sobrenome são obrigatórios.",
    emailInvalid: "E-mail inválido.",
    phoneRequired: "O telefone é obrigatório.",
    birthDateRequired: "A data de nascimento é obrigatória.",
    sexRequired: "O gênero é obrigatório.",
    stayDatesRequired: "As datas da estadia são obrigatórias.",
    checkoutBeforeCheckin: "A data de check-out não pode ser anterior à data de check-in.",
    birthCountryRequired: "O país de nascimento é obrigatório.",
    docTypeRequired: "O tipo de documento é obrigatório.",
    docNumberRequired: "O número do documento é obrigatório.",
    issuePlaceRequired: "O local de emissão do documento é obrigatório.",
    nationalityRequired: "A nacionalidade é obrigatória.",
    supportNumberRequired:
      "O número de suporte é obrigatório para nacionalidade espanhola (adulto).",
    saveFailed: "Não foi possível salvar.",
    saveError: "Erro ao salvar as alterações.",
  },
  toast: {
    saved: "Check-in atualizado com sucesso",
  },
};
